export default "__VITE_ASSET__1yWUZXy___"